import { API } from 'utils/Helper';

import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import App from "./App";
import { Provider } from 'react-redux';
import store from './store';

// Styles
import 'react-notifications-component/dist/theme.css'
import 'perfect-scrollbar/css/perfect-scrollbar.css';

import './utils/i18n';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import axios from 'axios';
import storage from 'utils/Storage';
import Cookies from 'js-cookie';

import { ThemeConfigProvider } from 'context/ThemeConfigContext';

const queryClient = new QueryClient();

// Suppress harmless ResizeObserver loop warning (from Swiper/layout libs)
const _origError = window.onerror;
window.onerror = function(message, ...args) {
  if (typeof message === 'string' && message.includes('ResizeObserver loop')) {
    return true; // suppress
  }
  return _origError ? _origError(message, ...args) : false;
};

// Setup global axios interceptor for refresh token
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    // If error is 401 and we haven't retried yet
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = storage.getKey('refreshToken') || Cookies.get('refreshToken');
      
      if (refreshToken) {
        try {
          // Attempt to refresh the token
          const res = await axios.post(`${API}/api/auth/refresh`, {
            refreshToken
          });
          
          if (res.data && res.data.token) {
            const newToken = res.data.token;
            storage.setKey('token', newToken);
            Cookies.set('session', newToken, { expires: 1 });
            
            // Update auth header
            originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
            return axios(originalRequest);
          }
        } catch (err) {
          // Refresh failed, logout user
          console.error('Refresh token failed:', err);
          storage.clear();
          Cookies.remove('session');
          Cookies.remove('refreshToken');
          window.location.href = '/';
        }
      }
    }
    return Promise.reject(error);
  }
);

const REACT_APP_BACKEND_URL = process.env.REACT_APP_MODE === 'production'
  ? (process.env.REACT_APP_PROD_BACKEND_URL || 'https://api.betanic.com')
  : (process.env.REACT_APP_DEV_BACKEND_URL  || 'http://localhost:3009');

function renderApp() {
  ReactDOM.render(
      <Provider store={store}>
          <QueryClientProvider client={queryClient}>
              <ThemeConfigProvider>
                  <App />
              </ThemeConfigProvider>
          </QueryClientProvider>
      </Provider>,
      document.getElementById("root")
  );
}

fetch(`${REACT_APP_BACKEND_URL}/website-config`)
  .then(r => r.json())
  .then(payload => {
    const data = payload?.success ? payload.data : payload;
    window.siteConfig = data || {};
    window.siteConfig.API_URL = REACT_APP_BACKEND_URL;
    
    const ts = Date.now();
    if (window.siteConfig.logo_big) window.siteConfig.logo_big += `?t=${ts}`;
    if (window.siteConfig.logo_small) window.siteConfig.logo_small += `?t=${ts}`;
    if (window.siteConfig.favicon) window.siteConfig.favicon += `?t=${ts}`;
    
    // Set Favicon
    if (window.siteConfig.favicon) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = `${REACT_APP_BACKEND_URL}${window.siteConfig.favicon}`;
    }

    // Set Dynamic Manifest
    try {
      const manifest = {
        short_name: window.siteConfig.website_name || "Betzplay",
        name: window.siteConfig.website_name || "Betzplay",
        icons: [
          {
            src: window.siteConfig.favicon ? `${REACT_APP_BACKEND_URL}${window.siteConfig.favicon}` : "favicon.png",
            sizes: "64x64 32x32 24x24 16x16",
            type: "image/png"
          }
        ],
        start_url: ".",
        display: "standalone",
        theme_color: "#000000",
        background_color: "#ffffff"
      };
      const blob = new Blob([JSON.stringify(manifest)], { type: 'application/json' });
      const manifestURL = URL.createObjectURL(blob);
      let manifestLink = document.querySelector("link[rel='manifest']");
      if (manifestLink) {
        manifestLink.setAttribute('href', manifestURL);
      }
    } catch (e) {
      console.error("Error setting dynamic manifest", e);
    }

    renderApp();
  })
  .catch(err => {
    console.error("Failed to load website config", err);
    window.siteConfig = {};
    renderApp();
  });


serviceWorker.unregister();


// const _ = require("lodash");
// const axios = require("axios");
// const config = require("../../config");
// const config = require("../../con")

// const Market = {};

// const Rate = Object.create(null);

// /**
//  * Get the price rate from market object
//  */
// Market.rate = function () {
//   return Rate;
// };

// /**
//  * Update from market price rate
//  */
// Market.update = function () {
//   axios({  headers:{
//     "Access-Control-Allow-Origin": "*",
//     "Access-Control-Allow-Methods":"*"
//   },
   
//     url: "https://pro-api.coinmarketcap.com/v1/cryptocurrency/listings/latest",
    
//    method: "GET",
//     headers: {
//       "X-CMC_PRO_API_KEY": config.COIN_MARKET_API,
//     },
//   }).then(function (req) {
//     var res = req.data;
//     var i = 0;
//     var data = res.data;
//     for (i in data) {
//       var b = data[i];
//       var coin = b.symbol;
//       if (
//         coin === "BTC" ||
//         coin === "ETH" ||
//         coin === "LTC" ||
//         coin === "DOGE" ||
//         coin === "XRP" ||
//         coin === "USDT" ||
//         coin === "BNB" ||
//         coin === "BCH" ||
//         coin === "TRX" ||
//         coin === "ADA" ||
//         coin === "TUSD" ||
//         coin === "NEXO" ||
//         coin === "BUSD" ||
//         coin === "USDC" ||
//         coin === "MKR" ||
//         coin === "USDP" ||
//         coin === "SOL" ||
//         coin === "MATIC" ||
//         coin === "SHIB"
//       ) {
//         var price = b["quote"]["USD"]["price"];
//         Rate[coin] = price;
//       }
//     }
//   });
// };

// /**
//  * Update from market price rate For Development Mode
//  */
// Market.dummyUpdate = function () {
//   let api = "http://localhost:3000/ticker.json";
//   axios({  headers:{
//     "Access-Control-Allow-Origin": "*",
//     "Access-Control-Allow-Methods":"*"
//   },
//     url: api,
//    method: "GET",
//   }).then(function (req) {
//     var res = req.data;
//     Object.keys(res).forEach(function (coin, key) {
//       let val = res[coin];
//       Rate[coin] = parseFloat(val);
//     });
//   });
// };

// module.exports = Market;
